/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Assistant_Not_In_RoomInputs */

const en_error_assistant_not_in_room = /** @type {(inputs: Error_Assistant_Not_In_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant answers who is on the page: reload it and ask again.`)
};

/**
* | output |
* | --- |
* | "The assistant answers who is on the page: reload it and ask again." |
*
* @param {Error_Assistant_Not_In_RoomInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_assistant_not_in_room = /** @type {((inputs?: Error_Assistant_Not_In_RoomInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Assistant_Not_In_RoomInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_assistant_not_in_room(inputs)
});